import * as React from 'react';
import { FixMeLater } from '../../utils';
import { TypographyBody, TypographyBodyProps } from '../Typography';
import { PriceBlockContext } from './PriceBlockContext';

export type PriceBlockCaptionProps = TypographyBodyProps;

export const PriceBlockCaption: React.ForwardRefExoticComponent<
    PriceBlockCaptionProps & React.RefAttributes<HTMLElement>
> = React.forwardRef(function PriceBlockCaption(
    props: PriceBlockCaptionProps,
    ref: React.ForwardedRef<FixMeLater>
): React.JSX.Element {
    const { align } = React.useContext(PriceBlockContext);
    return <TypographyBody ref={ref} size="xs" component="div" ta={align} {...props} />;
});
